import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiGet } from "../api/client";
import { PageHeader } from "../components/PageHeader";
import { formatShortDate, formatTimeParts } from "../lib/format";
import type { SurveySubmission } from "./SurveyDetailPage";

/**
 * Historical surveys list (`surveys/surveys.html`):
 * Patient | Doctor Seen | Received | Score (LED + "Patient rated N")
 * Row click → `/app/surveys/:id` (Angular opened a modal; route is deep-linkable).
 */
export function SurveysPage() {
  const navigate = useNavigate();
  const [rows, setRows] = useState<SurveySubmission[]>([]);
  useEffect(() => {
    apiGet<Array<{ submissions: SurveySubmission[] }>>(
      "/survey_submissions",
    ).then((d) => setRows(d?.[0]?.submissions ?? []));
  }, []);
  return (
    <>
      <PageHeader title="Surveys" />
      <div className="ne__surveys">
        <div className="ne__surveys__table">
          <div className="ne__table__padding">
            <table className="ne__table">
              <thead>
                <tr>
                  <th className="ne__table__eyebrow">Patient</th>
                  <th className="ne__table__eyebrow">Doctor Seen</th>
                  <th className="ne__table__eyebrow">Received</th>
                  <th className="ne__table__center ne__table__eyebrow">Score</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => {
                  const when = row.updated_at || row.created_at;
                  const { time, period } = formatTimeParts(when);
                  const patient =
                    row.appointment?.patient_name || row.patient_name || "";
                  const provider =
                    row.appointment?.provider_name || row.provider_name || "";
                  const score = Number(row.score) || 0;
                  return (
                    <tr
                      key={row.id}
                      className="nicehover cp"
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(`/app/surveys/${row.id}`)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          navigate(`/app/surveys/${row.id}`);
                        }
                      }}
                      tabIndex={0}
                      role="link"
                    >
                      <td className="ne__surveys__patient-name">{patient}</td>
                      <td className="ne__surveys__provider-name">{provider}</td>
                      <td className="ne__surveys__received-date">
                        <span>{when ? formatShortDate(when) : ""}</span>
                        {time ? (
                          <>
                            <span> at </span>
                            <span>{time}</span>
                            <span className="ne__period"> {period}</span>
                          </>
                        ) : null}
                      </td>
                      <td className="ne__table__center">
                        <div className="ne__table__led">
                          {score > 2 ? (
                            <i className="ne__score--positive" />
                          ) : null}
                          {score > 0 && score < 3 ? (
                            <i className="ne__score--negative" />
                          ) : null}
                          <span>Patient rated {score}</span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
